<template lang="html">
  <div class="content-wrapper">
  <div class="row">
    <div class="col-sm-12 grid-margin">
      <div class="row">
        <div class="col-sm-12 pr-0">
          <div class="d-lg-flex">
            <!-- <h3 class="text-light font-weight-bold mb-0 mr-5">{{lang=="ru"?"Добро пожаловать в личный кабинет":"Welcome to Dashboard"}}</h3> -->
            <span style='margin-left: auto;'>
              <!-- <h3 class="font-weight-bold" style='display: inline;'>{{lang=="ru"?"TradingAmmo баланс ":"TradingAmmo balance: "}}{{$parent.balance}}$</h3> -->
              <!-- <router-link to='/dashboard/settings' tag="button" class='btn btn-primary' style="margin:0 5px; float:right;">{{lang=="ru"?"Пополнить":"Refill"}}</router-link> -->
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-sm-6 col-xl-8 grid-margin stretch-card first-row-card">
      <div class="card">
        <div class="card-body px-0 pb-0 border-bottom">
          <div class="px-4">
          <div class="d-flex justify-content-between mb-2">
              <h3 class="card-title ml-2">{{lang=="ru"?"Профит":"Profit History"}}</h3>
              <!-- <h3 class="text-light font-weight-bold">{{lang=="ru"?"Прибыль за всё время":"All-time profit"}}: {{$parent.total_profit}}%</h3> -->
          </div>
          </div>


        </div>
        <div class="card-body pt-3 p-1">
          <b-nav pills style="border-bottom: none; margin-left: .5rem;" class='d-xs-none' justified>
          <!-- <div class="tab-content" style="overflow-y: scroll; max-height: 280px;"> -->
            <!-- <div class="tab-pane active show" id="input-1" role="tabpanel" aria-labelledby="input-tab"> -->
            <!-- <b-nav-item :active='selected_tab == 0' @click='selected_tab = 0'>{{lang=="ru"?"Ежедневно":"Daily"}}</b-nav-item> -->
            <b-nav-item class='nav-bar-item' v-if="$parent.plan_status>2" :active='$parent.selected_tab == 3' @click='$parent.selected_tab = 3'>{{lang=="ru"?"Прибыль по каждой стратегии":"Profit for each strategy"}}</b-nav-item>
            <b-nav-item v-if="$parent.plan_status>1" :active='$parent.selected_tab == 1' @click='$parent.selected_tab = 1'>{{lang=="ru"?"Еженедельно":"Weekly"}}</b-nav-item>
            <b-nav-item :active='$parent.selected_tab == 2' @click='$parent.selected_tab = 2'>{{lang=="ru"?"Ежемесячно":"Monthly"}}</b-nav-item>

          </b-nav>
          <div class="flot-chart-container flothcart-container-dashboard">
            <!-- <ProfitHistoryChart v-if="data_loaded" v-show="selected_tab == 0" :chartData="chartData" :styles='{height: (window.width > 576 ? 500 : 200)+"px"}' :options="{maintainAspectRatio: false, legend: {display: false}, scales: {xAxes: [{stacked: true}], yAxes: [{stacked: true}]}}"></ProfitHistoryChart> -->
            <ProfitHistoryChart v-if="data_loaded" v-show="$parent.selected_tab == 3" :chartData="strategyData" :styles='{height: (window.width > 576 ? 500 : 200)+"px"}' :options="{maintainAspectRatio: false, legend: {display: false}, scales: {xAxes: [{stacked: true}], yAxes: [{stacked: true}]}}"></ProfitHistoryChart>
            <ProfitHistoryChart v-if="data_loaded" v-show="$parent.selected_tab == 1" :chartData="weeklyData" :styles='{height: (window.width > 576 ? 500 : 200)+"px"}' :options="{maintainAspectRatio: false, legend: {display: false}, scales: {xAxes: [{stacked: true}], yAxes: [{stacked: true}]}}"></ProfitHistoryChart>
            <ProfitHistoryChart v-if="data_loaded" v-show="$parent.selected_tab == 2" :chartData="monthlyData" :styles='{height: (window.width > 576 ? 500 : 200)+"px"}' :options="{maintainAspectRatio: false, legend: {display: false}, scales: {xAxes: [{stacked: true}], yAxes: [{stacked: true}]}}"></ProfitHistoryChart>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-xl-4 grid-margin stretch-card first-row-card">

          <div class="card">
            <div class="card-body" style='overflow-y: scroll;'>
              <h4 class="card-title">{{lang=="ru"?"Последние сделки":"Latest actions"}}</h4>
              <div class='fixed-header-container'>
                <table class="table fixed_header">
                  <thead>
                    <tr>
                      <th>{{lang=="ru"?"Дата":"Date"}}</th>
                      <th>{{lang=="ru"?"Имя бота":"Bot name"}}</th>
                      <th>{{lang=="ru"?"Актив":"Asset"}}</th>
                      <th>{{lang=="ru"?"Тип":"Type"}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for='alert in latest_alerts' :key="alert.id">
                      <td>{{format_datetime(alert.timestamp).substr(0, 17)}}</td>
                      <td>{{alert.bot_name}}</td>
                      <td>{{alert.pair}}</td>
                      <td>
                        <label v-if="alert.side == 1" class="badge badge-success">{{lang=="ru"?"Kупить":"Buy"}}</label>
                        <label v-if="alert.side == -1 || alert.side == -2" class="badge badge-danger">{{lang=="ru"?"Продать":"Sell"}}</label>
                      </td>
                    </tr>
                    <tr v-if='latest_alerts.length == 0'>
                      <td colspan=4 style='text-align: center; font-size: 120%;'>{{lang=="ru"?"Сделок пока нет!":"No alerts yet!"}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body" style="overflow-x: scroll;">
          <h4 class="card-title">{{lang=="ru"?"Запущенные боты":"Running bots"}}</h4>
          <table class="table" style="min-width: 600px;">
            <thead>
              <tr>
                <th @click='sortByName()' style="cursor:pointer;">{{lang=="ru"?"Название":"Name"}}</th>
                <th>{{lang=="ru"?"Тип бота":"Bot type"}}</th>
                <th>{{lang=="ru"?"Актив":"Asset"}}</th>
                <th>TF</th>
                <th @click='sortByAmount()' style="cursor:pointer;">{{lang=="ru"?"Автоторговля":"Autotrade"}}</th>
                <th>{{lang=="ru"?"Истекает":"Expires"}}</th>
                <th>{{lang=="ru"?"Статус":"Status"}}</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for='strategy in this.$parent.subscriptions' :key='strategy.id'>
                <td>{{strategy.name}}</td>
                <td>{{strategy.bot_type}}</td>
                <td>{{strategy.pair}}</td>
                <td>{{strategy.timeframe}}</td>
                <td v-html='strategy.autotrade_amount ? strategy.autotrade_amount + " USDT" : "-"'></td>
                <td>{{format_date(strategy.active_until)}}</td>
                <td style="width:90px">
                  <label class="badge badge-danger" v-if='strategy.status == 0'>{{lang=="ru"?"Ошибка":"Error"}}</label>
                  <label class="badge badge-success" v-if='strategy.status == 1'>{{lang=="ru"?"В работе":"Running"}}</label>
                  <label class="badge badge-warning" v-if='strategy.status == 2'>{{lang=="ru"?"Приостановлено":"Paused"}}</label>
                  <label class="badge badge-danger" v-if='strategy.status == 3'>{{lang=="ru"?"Удалено":"Removed"}}</label>
                  <label class="badge badge-danger" v-if='strategy.status == 4'>{{lang=="ru"?"Окончено":"Expired"}}</label>
                </td>
                <td style="width:60px">
                  <img v-if="strategy.autotrade || strategy.percent_usdt" :id="'trading-icon-'+strategy.id" style="width:35px; cursor:pointer" src="/static/images/trading.png?r=1" alt="trading">
                  <b-tooltip v-if="strategy.autotrade || strategy.percent_usdt" :target="'trading-icon-'+strategy.id" triggers="hover">
                    That bot is trading
                  </b-tooltip>
                </td>
                <td>
                  <b-dropdown  variant="primary" toggle-class="text-decoration-none" no-caret v-if='strategy.status == 1 || strategy.status == 2'>
                    <template v-slot:button-content>
                      <i class="fa fa-cog"></i>
                    </template>
                    <!-- <b-dropdown-item href="#" v-if='strategy.status == 1 && $parent.plan_status==4' @click='strategy.big_subscription?setBigSubscriptiopionPause(strategy.id, 2):setSubscriptionStatus(strategy.id, 2)'><i class="fa fa-pause fa-fw"></i>{{lang=="ru"?"Пауза":"Pause"}} </b-dropdown-item> -->
                    <b-dropdown-item href="#" v-if='strategy.autotrade == false && strategy.percent_usdt == false' @click='only_alert(strategy.id)'><i class="fa fa-bell"></i>{{lang=="ru"?" Включить уведомления":" Switch on alerts"}} </b-dropdown-item>
                    <b-dropdown-item href="#" v-else='strategy.autotrade == false && strategy.percent_usdt == false' @click='switch_off(strategy.id)'><i class="fa fa-bell"></i>{{lang=="ru"?" Выключить уведомления":" Switch off"}} </b-dropdown-item>
                    <router-link tag="b-dropdown-item" :to="'/subscription/edit/'+strategy.id"><i class="fa fa-edit fa-fw"></i>{{lang=="ru"?"Редактировать":"Edit"}} </router-link>
                    <!-- <b-dropdown-item href="#" v-if='strategy.big_subscription==false' @click='(subSlatedForRemoval = strategy.id) && (removeSubModalVisible = true)'><i class="fa fa-trash-alt fa-fw"></i> {{lang=="ru"?"Удалить":"Delete"}}</b-dropdown-item> -->
                  </b-dropdown>
                  <b-button v-else-if='strategy.status == 3' v-b-tooltip.hover title="Restart" variant='success' @click='setSubscriptionStatus(strategy.id, 1)'>
                    <i class="fa fa-play"></i>
                  </b-button>
                  <!-- <b-button v-else v-b-tooltip.hover title="Delete" variant='danger' @click='subSlatedForRemoval == strategy.id && removeSubModalVisible == true'>
                    <i class="fa fa-play"></i>
                  </b-button> -->
                  <b-dropdown v-else variant="danger" toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <i class="fa fa-play"></i>
                    </template>
                    <!-- <b-dropdown-item href="#" @click='setSubscriptionStatus(strategy.id, 4, 1)'><i class="fa fa-play"></i> {{lang=="ru"?"Запустить":"Start"}}</b-dropdown-item> -->
                    <b-dropdown-item href="#" @click='(subSlatedForRemoval = strategy.id) && (removeSubModalVisible = true)'><i class="fa fa-trash-alt fa-fw"></i> {{lang=="ru"?"Удалить":"Delete"}}</b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
              <tr v-if='subscriptions.length == 0'>
                <td colspan=7 style='text-align: center; font-size: 120%;'>{{lang=="ru"?"У вас еще нет подписок!":"You have no subscriptions yet?"}} <router-link to="/dashboard/plans" tag="button" class="btn btn-primary">{{lang=="ru"?"Создать?":"Would you like to create?"}}</router-link></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <b-modal v-model="removeSubModalVisible">
    <template v-slot:modal-title>
      {{lang=="ru"?"Удалить подписку":"Remove subscription"}}

    </template>
    <b-alert show variant='danger'><b>{{lang=="ru"?"Это действие необратимо":"This action is irreversible"}}</b></b-alert>
    <p style='text-align: center;'>{{lang=="ru"?"Вы уверены?":"Are you sure?"}}</p>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Отменить":"Cancel"}}</b-button>
      <b-button variant='primary' @click='setSubscriptionStatus(subSlatedForRemoval, 3) && (subSlatedForRemoval = null) && (removeSubModalVisible = false) ; cancel()'>{{lang=="ru"?"Удалено":"Remove"}}</b-button>
    </template>
  </b-modal>
  <b-modal v-model="$parent.first_login">
    <template v-slot:modal-title>
      Hello
    </template>
    <p style='text-align: center;'>
      {{lang=="ru"?"Мы рады приветствовать вас на платформе. Наша основная функция — автотрейдинг. Вы можете выбрать понравившиеся стратегии в разделе «Боты» и подключить свой биржевой аккаунт к платформе в «Настройки аккаунта». Указать сумму к торговли можно во вкладке «Свойства», открыв стратегию. Вы также можете поэксперементировать с вводными данными и таймфреймом, но предлагаемые варианты являются одними из самых эффективных. Наш простой интерфейс не должен вызывать проблем, но если что-то непонятно — мы всегда готовы ответить на все интересующие вопросы.":"We are glad to welcome you to the platform. Our main function is auto trading. You can choose the strategies you like in the 'Bots Market' and connect your exchange account in 'Account Settings'. You can specify the amount to trade in the  Properties tab by opening the strategy. You can also experiment with inputs and time frame, but the suggested options are among the most effective. Our simple interface should not cause problems, but if something is not clear, we are always ready to answer all your questions."}}
    </p>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click="notification(); cancel()">{{lang=="ru"?"Хорошо":"OK"}}</b-button>
    </template>
  </b-modal>
    <b-modal v-model="confirmPlan">
    <template v-slot:modal-title>
      Hello
    </template>
    <p style='text-align: center;'>
      {{lang=="ru"?"You can find our plans in filed Status":"You can find our plans in filed Status"}}
    </p>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click="plan_link(); cancel()">{{lang=="ru"?"Хорошо":"OK"}}</b-button>
    </template>
  </b-modal>
  <b-modal v-model="bigSubscriptionPauseModal">
    <template v-slot:modal-title>
      Notification
    </template>
    <p style='text-align: center;'>
      {{lang=="ru"?"Все 3 бота будут в режиме паузы?":"All 3 bots would be on pause?"}}
    </p>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Отменить":"Cancel"}}</b-button>
      <b-button variant='primary' @click='setBigSubscriptiopionStatus(2)'>{{lang=="ru"?"Хорошо":"OK"}}</b-button>
    </template>
  </b-modal>
  <b-modal v-model="bigSubscriptionResumModal">
    <template v-slot:modal-title>
      Notification
    </template>
    <p style='text-align: center;'>
      {{lang=="ru"?"Все 3 бота будут перезагружены?":"All 3 bots would be on restart?"}}
    </p>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Отменить":"Cancel"}}</b-button>
      <b-button variant='primary' @click='setBigSubscriptiopionStatus(1)'>{{lang=="ru"?"Хорошо":"OK"}}</b-button>
    </template>
  </b-modal>
</div>
</template>

<script>
import ProfitHistoryChart from './ProfitHistoryChart'
export default {
  components: {ProfitHistoryChart},
  data () {
    return {
      lang:'en',
      data_loaded: false,
      balance: 0.0,
      subscriptions: [],
      profit_history: [],
      weekly_history: [],
      monthly_history: [],
      monthly_profit_history: [],
      latest_alerts: [],
      chartData: [],
      weeklyData: [],
      monthlyData: [],
      strategyData:[],
      selected_tab: 3,
      strategy_history:[],
      removeSubModalVisible: false,
      subSlatedForRemoval: null,
      window: {
        width: 0
      },
      confirmEmail: false,
      bigSubscriptionResumModal:false,
      bigSubscriptionPauseModal:false,
      sort_name:false,
      sort_amount:false,
      confirmPlan:false
    }
  },
  created () {
    this.lang = this.$cookie.get('lang');
    this.refresh_extended_info()
    window.addEventListener('resize', this.handle_resize)
    this.handle_resize();
    this.confirm();
    this.refresh_strategy_info();
    // setTimeout(function(){
    //   if(this.$parent.plan_status==1){
    //     this.selected_tab=2
    //   }else if(this.$parent.selected_tab==2){
    //     this.selected_tab=1
    //   }
    //   console.log("selected tab: " + this.selected_tab)
    // },3000);
    // this.check_expire();
  },
  methods: {
    plan_link(){
      window.location.href="https://tradingapp.pro/app/#/dashboard/plans"
    },
    confirm(){
      var confirmCookie = this.$cookie.get('fslogin');
      if(confirmCookie == 'exist'){
        this.confirmEmail = true;
      }
    },
    sortByName(){
      if(this.sort_name==false){
        this.$parent.sortSubscriptions(this.sort_name);
        this.sort_name=true
      }else{
        this.$parent.sortSubscriptions(this.sort_name);
        this.sort_name=false
      }
    },
    sortByAmount(){
      if(this.sort_amount==false){
        this.$parent.sortSubscriptionsByamount(this.sort_amount);
        this.sort_amount=true
      }else{
        this.$parent.sortSubscriptionsByamount(this.sort_amount);
        this.sort_amount=false
      }
    },
    setBigSubscriptiopionPause(){
      this.bigSubscriptionPauseModal=true
    },
    setBigSubscriptiopionResume(){
      this.bigSubscriptionResumModal=true
    },
    notification(){
      this.$cookie.delete('fslogin', {domain: 'tradingapp.pro'});
      this.confirmPlan=true
    },
    latest_binance_balance () {
      if (this.profit_history.length === 0) return '--'
      else return this.profit_history[this.profit_history.length - 1].profit
    },
    latest_binance_balance_refresh () {
      if (this.profit_history.length === 0) return 'long time ago'
      else {
        return this.profit_history[this.profit_history.length - 1].date
      }
    },
    loadChartData () {
      this.chartData = {
        labels: this.profit_history.map((measurement) => { return measurement.date }),
        datasets: [
          {
            label: 'Profit (%)',
            backgroundColor: '#f87979',
            data: this.profit_history.map((measurement) => { return (measurement.profit * 100).toFixed(3)})
          }
        ]
      }
      this.weeklyData = {
        labels: this.weekly_history.map((measurement) => { return measurement.date }),
        datasets: [
          {
            label: 'Profit (%)',
            backgroundColor: '#f87979',
            data: this.weekly_history.map((measurement) => { return (measurement.profit * 100).toFixed(3)})
          }
        ]
      }
      this.monthlyData = {
        labels: this.monthly_history.map((measurement) => { return  this.$moment(measurement.date,'YYYY-MM-DD').subtract(1,'months').format('YYYY-MM-DD') }),
        datasets: [
          {
            label: 'Profit (%)',
            backgroundColor: '#f87979',
            data: this.monthly_history.map((measurement) => { return (measurement.profit * 100).toFixed(3)})
          }
        ]
      }
    },

    loadChartStrategy () {
      this.strategyData = {
        labels: this.strategy_history.map((measurement) => { return  measurement.title }),
        datasets: [
          {
            label: 'Profit (%)',
            backgroundColor: '#f87979',
            data: this.strategy_history.map((measurement) => { return measurement.profitability })
          },
          // {
          //   label: 'Price ($)',
          //   backgroundColor: '#0ddbb9',
          //   data: this.strategy_history.map((measurement) => { return measurement.price })
          // },
          // {
          //   label: 'connections',
          //   backgroundColor: '#1720ea',
          //   data: this.strategy_history.map((measurement) => { return measurement.connections })
          // }
        ]
      }
    },
    format_date (timestamp) {
      var ts = new Date(timestamp * 1000)
      return ts.toLocaleDateString()
    },
    format_datetime (timestamp) {
      var ts = new Date(timestamp * 1000)
      return ts.toLocaleString()
    },
    // check_expire(){
    //   this.axios.get('/subscription/straighy_check_expired', {withCredentials: true})
    //     .then((response) => {
    //         console.log("schedule success !");
    //         console.log(response);
    //     })
    // },
    setBigSubscriptiopionStatus(newStatus){
      this.axios.get('/subscription/big_change_status', {params: {status: newStatus}, withCredentials: true})
        .then((response) => {
          this.bigSubscriptionPauseModal=false
          this.bigSubscriptionResumModal=false
          if (response.data.success) {
            this.$parent.refresh_user_info()
          }else{
            if (response.data.error_message){
              this.$root.$bvToast.toast(response.data.error_message, {
                  title: 'Notification',
                  variant: 'warning',
                  solid: true
              })
            }
          }
        })
    },
    setSubscriptionStatus (subscriptionId, newStatus, restart_state=null) {
      this.axios.get('/subscription/change_status/' + subscriptionId, {params: {status: newStatus, restart_state:restart_state}, withCredentials: true})
        .then((response) => {
          if (response.data.success) {
            this.$parent.refresh_user_info()
          }else{
            if (response.data.error_message){
              this.$root.$bvToast.toast(response.data.error_message, {
                  title: 'Notification',
                  variant: 'warning',
                  solid: true
              })
            }
          }
        })
    },

    switch_off(id){
        this.axios.post('/subscription/switch_off', {
          subscription_id: id
        }, {withCredentials: true}).then(response => {
          console.log(response)
          if (response.data.success) {
            this.$parent.refresh_user_info()
            this.$root.$bvToast.toast('Saved successfully', {
              title: 'Notification',
              variant: 'success',
              solid: true
            })
          }
        })
    },

    only_alert(id) {
      var total_count=0
      for(var i=0; i<this.$parent.subscriptions.length; i++){
        var subscription=this.$parent.subscriptions[i];
        if(subscription.autotrade || subscription.percent_usdt){
          total_count++
        }
      }
      var user_status=this.$parent.plan_status
        if(user_status==2){
          if(total_count>=1){
            this.$root.$bvToast.toast("You are using 1 auto-tradings already", {
                title: 'Notification',
                variant: 'warning',
                solid: true
            })
            return false;
          }
        }else if(user_status==3){
          if(total_count>=2){
            this.$root.$bvToast.toast("You are using 2 auto-tradings already", {
                title: 'Notification',
                variant: 'warning',
                solid: true
            })
            return false;
          }
        }else if(user_status==4){
          if(total_count>=3){
            this.$root.$bvToast.toast("You are using 3 auto-tradings already", {
                title: 'Notification',
                variant: 'warning',
                solid: true
            })
            return false;
          }
        }
        this.axios.post('/subscription/only_alert', {
          subscription_id: id
        }, {withCredentials: true}).then(response => {
          console.log(response)
          if (response.data.success) {
            this.$parent.refresh_user_info()
            this.$root.$bvToast.toast('Saved successfully', {
              title: 'Notification',
              variant: 'success',
              solid: true
            })
          }
        })
    },

    refresh_extended_info () {
      this.axios.get('/user/extended_info', {withCredentials: true})
        .then((userInfo) => {
          userInfo = userInfo.data
          this.subscriptions = userInfo.subscriptions.sort((a, b) => { return a.status - b.status })
          this.latest_alerts = userInfo.latest_alerts
          this.profit_history = userInfo.profit_history
          this.weekly_history = userInfo.weekly_history
          this.monthly_history = userInfo.monthly_history
          this.loadChartData()
          console.log(this.profit_history)
          this.data_loaded = true
        })
    },
    refresh_strategy_info () {
      this.axios.get('/subscription/get_profit', {withCredentials: true})
        .then((strategyInfo) => {
          console.log("===============profit result=================")
          console.log(strategyInfo);
          this.strategy_history = strategyInfo.data.data
          this.loadChartStrategy()
          this.data_loaded = true
        })
    },
    handle_resize () {
      this.window.width = window.innerWidth
    }
  }
}
</script>

<style lang="css" scoped>
.first-row-card {
  height: 650px;
}

@media (max-width: 576px) {
  .first-row-card {
    height: 350px;
  }
  .nav-bar-item>.nav-link{
    min-height: fit-content !important;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 100%;
    display: -webkit-box !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardMainView.vue